<template>
    <div>
        <div v-if="betfairLoggedIn_loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
            <CSpinner
                color="info"
                style="width:4rem;height:4rem;"
            />
        </div>
        <div v-else>
            <div v-if="!betfairLoggedIn">
                <div style="margin: auto;  width: 300px;">
                    <div style="" class="form-group ">
                        <label style="padding-left: 5px; padding-top: 15px;">betfair user</label>
                        <CInput type="text" :value.sync="betfair_user"></CInput>
                    </div>
                    <div style="" class="form-group ">
                        <label style="padding-left: 5px; padding-top: 15px;">betfair password</label>
                        <CInput type="password" :value.sync="betfair_password"></CInput>
                    </div>
                    <div style="" class="form-group " v-if="betfair_authcode_required">
                        <label style="padding-left: 5px; padding-top: 15px;">auth code</label>
                        <CInput type="text" :value.sync="betfair_authcode"></CInput>
                    </div>
                    <div class="container-login100-form-btn" style=" padding-top: 15px;">
                        <CButton type="submit" color="primary" style="padding: 9px 40px; border-radius: 1.25rem; border: none; color: white;" @click="betfair_login">Login</CButton>
                    </div>
                </div>
                <div style="padding-top: 20px;">
                    <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
                        <CSpinner
                            color="info"
                            style="width:4rem;height:4rem;"
                        />
                    </div>
                    <div v-else style="display: flex;">
                        <div style="flex: 7; max-width: 100%;" class="post-tip-container">
                            <CCard bodyWrapper class="card_background" style="height: 529px;">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab title="active">
                                        <div title="My strategies">
                                            <div style="margin-bottom: 5px;">
                                                <span style="color: blue;">My strategies</span>
                                            </div>
                                            <CRow class="table-layout">
                                                <CCol sm="12">                    
                                                    <table :key="myStrategyKey"  style="width:  100%; font-size: 13.5px;">                        
                                                        <tr class="table-header-stick">
                                                            <th class="dualHeader1" colspan="1">view</th>
                                                            <th class="dualHeader1" colspan="1">strategy name</th>
                                                            <th class="dualHeader1" colspan="1">user</th>
                                                            <th class="dualHeader1" colspan="1">Win rate(%)</th>
                                                            <th class="dualHeader1" colspan="1">ROI(%)</th>
                                                            <th class="dualHeader1" colspan="1">P/L</th>
                                                            <th class="dualHeader1" colspan="1">Pending</th>
                                                            <th class="dualHeader1" colspan="1">Total tips</th>
                                                            <th class="dualHeader1" colspan="1">Play/Stop</th>
                                                            <th class="dualHeader1" colspan="1">Delete</th>
                                                            <th class="dualHeader1" colspan="1">Settings</th>
                                                            <th class="dualHeader1" colspan="1">Staked</th>
                                                            <th class="dualHeader1" colspan="1">Curr Staked</th>
                                                            <th class="dualHeader1" colspan="1">Curr P/L</th>
                                                            <th class="dualHeader1" colspan="1">View</th>                            
                                                            <th class="dualHeader1" colspan="1">Auto</th>
                                                        </tr>
                                                        
                                                        <tr v-for="(item, index) in myStrategies_active"> 
                                                            
                                                            <td style="padding: 0px">
                                                                <CInputCheckbox class="check-box" :checked.sync = "item.view" @update:checked="strategyView(item._id, item.view)" />
                                                            </td> 
                                                            <td style="padding: 0px"> {{ item.strategyName }}</td>
                                                            <td style="padding: 0px"> {{ item.userName }}</td>
                                                            <td style="padding: 0px"> {{ item.winRate }}</td>
                                                            <td style="padding: 0px"> {{ item.roi }}</td>
                                                            <td style="padding: 0px"> {{ item.pl }}</td>
                                                            <td style="padding: 0px"> {{ item.pendingTips }} ({{ item.pendingMatchedTips }}, {{ item.pendingPartialMatchedTips }})</td>
                                                            <td style="padding: 0px"> {{ item.totalTips }}</td>
                                                            <td style="padding: 0px"> <CInputCheckbox class="check-box" :checked.sync = "item.play_stop" @update:checked="playStrategy(item._id, item.play_stop)" /></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionStrategy(item._id, false)">Archive</CButton></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" v-b-modal="item._id">options</CButton></td>
                                                            <td style="padding: 0px"> {{ item.staked }}</td>
                                                            <td style="padding: 0px"> {{ item.pending_stakeTotal }}</td>
                                                            <td style="padding: 0px"> {{ item.curPL }}</td>
                                                            <!-- <td style="padding: 0px"> <CInputCheckbox class="check-box" :checked.sync = "item.select" /></td> -->
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionViewTips(item._id)">view</CButton></td>
                                                            <td style="padding: 0px"> <CInputCheckbox class="check-box" :checked.sync = "item.auto" @update:checked="autoStrategy(item._id, item.auto, item.betfair_setting)" /></td>
                                                        </tr>
                                                    </table>
                                                </CCol>                
                                            </CRow>
                                        </div>
                                    </CTab>
                                    <CTab title="archived">
                                        <div title="My strategies">
                                            <div style="margin-bottom: 5px;">
                                                <span style="color: blue;">My strategies</span>
                                            </div>
                                            <CRow class="table-layout">
                                                <CCol sm="12">                    
                                                    <table style="width:  100%; font-size: 13.5px;">                        
                                                        <tr class="table-header-stick">
                                                            <th class="dualHeader1" colspan="1">strategy name</th>
                                                            <th class="dualHeader1" colspan="1">user</th>
                                                            <th class="dualHeader1" colspan="1">Win rate(%)</th>
                                                            <th class="dualHeader1" colspan="1">ROI(%)</th>
                                                            <th class="dualHeader1" colspan="1">P/L</th>
                                                            <th class="dualHeader1" colspan="1">Pending</th>
                                                            <th class="dualHeader1" colspan="1">Total tips</th>
                                                            <th class="dualHeader1" colspan="1">Restore</th>
                                                            <th class="dualHeader1" colspan="1">Delete</th>
                                                            <th class="dualHeader1" colspan="1">View</th>
                                                        </tr>
                                                        
                                                        <tr v-for="(item, index) in myStrategies_archived"> 
                                                            <td style="padding: 0px"> {{ item.strategyName }}</td>
                                                            <td style="padding: 0px"> {{ item.userName }}</td>
                                                            <td style="padding: 0px"> {{ item.winRate }}</td>
                                                            <td style="padding: 0px"> {{ item.roi }}</td>
                                                            <td style="padding: 0px"> {{ item.pl }}</td>
                                                            <td style="padding: 0px"> {{ item.pendingTips }} ({{ item.pendingMatchedTips }}, {{ item.pendingPartialMatchedTips }})</td>
                                                            <td style="padding: 0px"> {{ item.totalTips }}</td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionStrategy(item._id, true)">restore</CButton></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionStrategy(item._id, null)">delete</CButton></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionViewTips(item._id)">view</CButton></td>
                                                        </tr>
                                                    </table>
                                                </CCol>                
                                            </CRow>
                                        </div>
                                    </CTab>
                                </CTabs>

                                <b-modal v-for="(item, index) in myStrategies_active"
                                    :id="item._id" 
                                    @ok="handleOk($event, item._id)"
                                    @cancel=""
                                    @shown="modal_setFields(item.betfair_setting)"
                                    title="Setting options"
                                    >            
                                   <div style="display: flex">

                                        <div style="flex: 1">
                                            <div title="stakes" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Stakes</label>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Budget</label>
                                                        <CInput type="number" :value.sync="betfair_setting.budget"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">size % (compounding)</label>
                                                        <CInput type="number" :value.sync="betfair_setting.size_percent"></CInput>
                                                    </div>
                                                </div>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Flat Stake</label>
                                                        <CInput type="number" :value.sync="betfair_setting.flat_stake"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Leverage</label>
                                                        <CInput type="number" :value.sync="betfair_setting.leverage"></CInput>
                                                    </div>
                                                </div>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <CSelect
                                                            label="Lay Stake"
                                                            :options="lay_stake_Options"
                                                            :value.sync="betfair_setting.lay_stake"
                                                        />
                                                    </div>
                                                    <div style="flex: 1">
                                                    </div>
                                                </div>
                                            </div>
                                            <div title="stakes" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Risk</label>
                                                <div style="display: flex">                                    
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;" v-c-tooltip="'Max esposure (max amount staked at the same time)'">Max esposure</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_esposure"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;" v-c-tooltip="'Max esposure for single bet'">for single bet</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_esposure_per_bet"></CInput>
                                                    </div>
                                                </div>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;" v-c-tooltip="'Stop loss (stop copy strategy when it reaches negative P/L limit)'">Stop loss...</label>
                                                        <CInput type="number" :value.sync="betfair_setting.stop_loss"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Stop loss daily</label>
                                                        <CInput type="number" :value.sync="betfair_setting.stop_loss_daily"></CInput>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div title="stakes" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Profits</label>
                                                <div class="form-group ">
                                                    <label style="padding-left: 5px;">target profit and stop auto (daily)</label>
                                                    <CInput type="number" :value.sync="betfair_setting.target_profit"></CInput>
                                                </div>
                                                
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="float: left;  margin-right: 25px; padding-left: 5px;">stop auto after reaching new profit (daily)</label>
                                                    <CInputCheckbox class="check-box" :checked.sync = "betfair_setting.stop_after_target_profit" />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div style="flex: 0.1;">
                                        </div>
                                        <div style="flex: 1;">
                                            
                                            <div title="tips" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Tips</label>
                                                <div style="display: flex">                                    
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Max tips per day</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_tips"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Max tips at same time</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_tips_matched"></CInput>
                                                    </div>
                                                </div> 
                                            </div>
                                            <div title="cashout-functions" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Cashout functions</label>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">Auto cash out:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.auto_cashout" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take Free bet:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.free_bet" />
                                                </div>
                                            </div>
                                            <div title="entry-functions" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Entry functions</label>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">Swap:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.swap" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take tip odd price Live:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.take_tip_odd_price" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take tip odd price:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.take_tip_published_odd_price" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take other side odd price:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.take_otherside_odd_price" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">keep bet once event turns in-play:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.keep_bet" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">bet again if lapsed:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.bet_again" />
                                                </div>
                                            </div>
                                            <div title="Statistics" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Statistics</label>
                                                <div>
                                                    <CButton color="info" class="m-2" @click="actionResetStrategyStats(item._id)" >Reset stats</CButton>
                                                </div>
                                                
                                            </div>
                                        </div>
                                   </div>
                                   <template #modal-footer="{ ok, cancel, hide }">
                                        <b-button size="sm" variant="success" @click="ok(item._id)">
                                            Save
                                        </b-button>
                                        <b-button size="sm" variant="danger" @click="cancel()">
                                            Cancel
                                        </b-button>                
                                    </template>
                                </b-modal>
                            </CCard>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else style="padding-top: 20px; padding-left: 30px">
                <span>You already logged in to betfair</span>
                <CButton type="submit" color="primary" style="padding: 9px 20px; border-radius: 1.25rem; border: none; color: white; margin-left: 10px;" @click="betfair_logout">Logout</CButton>

                <div style="padding-top: 20px;">
                    <div v-if="loading" class="d-flex justify-content-center m-2 tip_body" style="height: 10px;">
                        <CSpinner
                            color="info"
                            style="width:4rem;height:4rem;"
                        />
                    </div>
                    <div v-else style="display: flex;">
                        <div style="flex: 7; max-width: 70%;" class="post-tip-container">
                            <!-- <div v-if="loading" style="height: 10px;">
                                <b-progress :value="current_counter" :max="100" animated></b-progress>
                            </div> -->
                            <CCard bodyWrapper class="card_background" style="height: 529px;">
                                <CTabs variant="tabs" :active-tab="0">
                                    <CTab title="active">
                                        <div title="My strategies">
                                            <div style="margin-bottom: 5px;">
                                                <span style="color: blue;">My strategies</span>
                                            </div>
                                            <CRow class="table-layout">
                                                <CCol sm="12">                    
                                                    <table :key="myStrategyKey"  style="width:  100%; font-size: 13.5px;">                        
                                                        <tr class="table-header-stick">
                                                            <th class="dualHeader1" colspan="1">view</th>
                                                            <th class="dualHeader1" colspan="1">strategy name</th>
                                                            <th class="dualHeader1" colspan="1">user</th>
                                                            <th class="dualHeader1" colspan="1">Win rate(%)</th>
                                                            <th class="dualHeader1" colspan="1">ROI(%)</th>
                                                            <th class="dualHeader1" colspan="1">P/L</th>
                                                            <th class="dualHeader1" colspan="1">Pending</th>
                                                            <th class="dualHeader1" colspan="1">Total tips</th>
                                                            <th class="dualHeader1" colspan="1">Play/Stop</th>
                                                            <th class="dualHeader1" colspan="1">Delete</th>
                                                            <th class="dualHeader1" colspan="1">Settings</th>
                                                            <th class="dualHeader1" colspan="1">Staked</th>
                                                            <th class="dualHeader1" colspan="1">Curr Staked</th>
                                                            <th class="dualHeader1" colspan="1">Curr P/L</th>
                                                            <th class="dualHeader1" colspan="1">View</th>                            
                                                            <th class="dualHeader1" colspan="1">Auto</th>
                                                        </tr>
                                                        
                                                        <tr v-for="(item, index) in myStrategies_active"> 
                                                            
                                                            <td style="padding: 0px">
                                                                <CInputCheckbox class="check-box" :checked.sync = "item.view" @update:checked="strategyView(item._id, item.view)" />
                                                            </td> 
                                                            <td style="padding: 0px"> {{ item.strategyName }}</td>
                                                            <td style="padding: 0px"> {{ item.userName }}</td>
                                                            <td style="padding: 0px"> {{ item.winRate }}</td>
                                                            <td style="padding: 0px"> {{ item.roi }}</td>
                                                            <td style="padding: 0px"> {{ item.pl }}</td>
                                                            <td style="padding: 0px"> {{ item.pendingTips }} ({{ item.pendingMatchedTips }}, {{ item.pendingPartialMatchedTips }})</td>
                                                            <td style="padding: 0px"> {{ item.totalTips }}</td>
                                                            <td style="padding: 0px"> <CInputCheckbox class="check-box" :checked.sync = "item.play_stop" @update:checked="playStrategy(item._id, item.play_stop)" /></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionStrategy(item._id, false)">Archive</CButton></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" v-b-modal="item._id">options</CButton></td>
                                                            <td style="padding: 0px"> {{ item.staked }}</td>
                                                            <td style="padding: 0px"> {{ item.pending_stakeTotal }}</td>
                                                            <td style="padding: 0px"> {{ item.curPL }}</td>
                                                            <!-- <td style="padding: 0px"> <CInputCheckbox class="check-box" :checked.sync = "item.select" /></td> -->
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionViewTips(item._id)">view</CButton></td>
                                                            <td style="padding: 0px"> <CInputCheckbox class="check-box" :checked.sync = "item.auto" @update:checked="autoStrategy(item._id, item.auto, item.betfair_setting)" /></td>
                                                        </tr>
                                                    </table>
                                                </CCol>                
                                            </CRow>
                                        </div>
                                    </CTab>
                                    <CTab title="archived">
                                        <div title="My strategies">
                                            <div style="margin-bottom: 5px;">
                                                <span style="color: blue;">My strategies</span>
                                            </div>
                                            <CRow class="table-layout">
                                                <CCol sm="12">                    
                                                    <table style="width:  100%; font-size: 13.5px;">                        
                                                        <tr class="table-header-stick">
                                                            <th class="dualHeader1" colspan="1">strategy name</th>
                                                            <th class="dualHeader1" colspan="1">user</th>
                                                            <th class="dualHeader1" colspan="1">Win rate(%)</th>
                                                            <th class="dualHeader1" colspan="1">ROI(%)</th>
                                                            <th class="dualHeader1" colspan="1">P/L</th>
                                                            <th class="dualHeader1" colspan="1">Pending</th>
                                                            <th class="dualHeader1" colspan="1">Total tips</th>
                                                            <th class="dualHeader1" colspan="1">Restore</th>
                                                            <th class="dualHeader1" colspan="1">Delete</th>
                                                            <th class="dualHeader1" colspan="1">View</th>
                                                        </tr>
                                                        
                                                        <tr v-for="(item, index) in myStrategies_archived"> 
                                                            <td style="padding: 0px"> {{ item.strategyName }}</td>
                                                            <td style="padding: 0px"> {{ item.userName }}</td>
                                                            <td style="padding: 0px"> {{ item.winRate }}</td>
                                                            <td style="padding: 0px"> {{ item.roi }}</td>
                                                            <td style="padding: 0px"> {{ item.pl }}</td>
                                                            <td style="padding: 0px"> {{ item.pendingTips }} ({{ item.pendingMatchedTips }}, {{ item.pendingPartialMatchedTips }})</td>
                                                            <td style="padding: 0px"> {{ item.totalTips }}</td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionStrategy(item._id, true)">restore</CButton></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionStrategy(item._id, null)">delete</CButton></td>
                                                            <td style="padding: 0px"> <CButton color="info" class="m-2" @click="actionViewTips(item._id)">view</CButton></td>
                                                        </tr>
                                                    </table>
                                                </CCol>                
                                            </CRow>
                                        </div>
                                    </CTab>
                                </CTabs>

                                <b-modal v-for="(item, index) in myStrategies_active"
                                    :id="item._id" 
                                    @ok="handleOk($event, item._id)"
                                    @cancel=""
                                    @shown="modal_setFields(item.betfair_setting)"
                                    title="Setting options"
                                    >            
                                   <div style="display: flex">

                                        <div style="flex: 1">
                                            <div title="stakes" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Stakes</label>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Budget</label>
                                                        <CInput type="number" :value.sync="betfair_setting.budget"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">size % (compounding)</label>
                                                        <CInput type="number" :value.sync="betfair_setting.size_percent"></CInput>
                                                    </div>
                                                </div>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Flat Stake</label>
                                                        <CInput type="number" :value.sync="betfair_setting.flat_stake"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Leverage</label>
                                                        <CInput type="number" :value.sync="betfair_setting.leverage"></CInput>
                                                    </div>
                                                </div>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <CSelect
                                                            label="Lay Stake"
                                                            :options="lay_stake_Options"
                                                            :value.sync="betfair_setting.lay_stake"
                                                        />
                                                    </div>
                                                    <div style="flex: 1">
                                                    </div>
                                                </div>
                                            </div>
                                            <div title="stakes" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Risk</label>
                                                <div style="display: flex">                                    
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;" v-c-tooltip="'Max esposure (max amount staked at the same time)'">Max esposure</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_esposure"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;" v-c-tooltip="'Max esposure for single bet'">for single bet</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_esposure_per_bet"></CInput>
                                                    </div>
                                                </div>
                                                <div style="display: flex">
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;" v-c-tooltip="'Stop loss (stop copy strategy when it reaches negative P/L limit)'">Stop loss...</label>
                                                        <CInput type="number" :value.sync="betfair_setting.stop_loss"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Stop loss daily</label>
                                                        <CInput type="number" :value.sync="betfair_setting.stop_loss_daily"></CInput>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                            <div title="stakes" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Profits</label>
                                                <div class="form-group ">
                                                    <label style="padding-left: 5px;">target profit and stop auto (daily)</label>
                                                    <CInput type="number" :value.sync="betfair_setting.target_profit"></CInput>
                                                </div>
                                                
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="float: left;  margin-right: 25px; padding-left: 5px;">stop auto after reaching new profit (daily)</label>
                                                    <CInputCheckbox class="check-box" :checked.sync = "betfair_setting.stop_after_target_profit" />
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div style="flex: 0.1;">
                                        </div>
                                        <div style="flex: 1;">
                                            
                                            <div title="tips" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Tips</label>
                                                <div style="display: flex">                                    
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Max tips per day</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_tips"></CInput>
                                                    </div>
                                                    <div style="flex: 1" class="form-group ">
                                                        <label style="padding-left: 5px;">Max tips at same time</label>
                                                        <CInput type="number" :value.sync="betfair_setting.max_tips_matched"></CInput>
                                                    </div>
                                                </div> 
                                            </div>
                                            <div title="cashout-functions" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Cashout functions</label>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">Auto cash out:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.auto_cashout" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take Free bet:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.free_bet" />
                                                </div>
                                            </div>
                                            <div title="entry-functions" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Entry functions</label>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">Swap:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.swap" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take tip odd price Live:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.take_tip_odd_price" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take tip odd price:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.take_tip_published_odd_price" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">take other side odd price:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.take_otherside_odd_price" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">keep bet once event turns in-play:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.keep_bet" />
                                                </div>
                                                <div class="form-group " style="height: 30px;">
                                                    <label style="padding-left:  5px; margin-right: 5px;">bet again if lapsed:</label>
                                                    <CInputCheckbox style="display:  inline;" class="check-box" :checked.sync = "betfair_setting.bet_again" />
                                                </div>
                                            </div>
                                            <div title="Statistics" class="dlg-setting-section">
                                                <label class="dlg-setting-section-title">Statistics</label>
                                                <div>
                                                    <CButton color="info" class="m-2" @click="actionResetStrategyStats(item._id)" >Reset stats</CButton>
                                                </div>
                                                
                                            </div>
                                        </div>
                                   </div>
                                   <template #modal-footer="{ ok, cancel, hide }">
                                        <b-button size="sm" variant="success" @click="ok(item._id)">
                                            Save
                                        </b-button>
                                        <b-button size="sm" variant="danger" @click="cancel()">
                                            Cancel
                                        </b-button>                
                                    </template>
                                </b-modal>
                            </CCard>
                            <CCard bodyWrapper class="card_background" style="height: 488px;">
                                <div title="Events pending">
                                    <div style="margin-bottom: 5px;">
                                        <span style="color: blue;">Events (pending)</span>
                                    </div>
                                    <CRow class="table-layout">
                                        <CCol sm="12">                    
                                            <table style="width:  100%; font-size: 13.5px;">                        
                                                <tr class="table-header-stick">
                                                    <th class="dualHeader1" colspan="1">view</th>
                                                    <th class="dualHeader1" colspan="1">event name</th>
                                                    <th class="dualHeader1" colspan="1" @click="tipSort('strategyName')">strategy name <!-- <span style="content: '\2195';">&#8597;</span> --></th>
                                                    <th class="dualHeader1" colspan="1">type</th>
                                                    <th class="dualHeader1" colspan="1">B/L</th>
                                                    <th class="dualHeader1" colspan="1">predict</th>
                                                    <th class="dualHeader1" colspan="1">stake (pt)</th>
                                                    <th class="dualHeader1" colspan="1">stake ($)</th>
                                                    <th class="dualHeader1" colspan="1" @click="tipSort('status')">status</th>
                                                    <th class="dualHeader1" colspan="1" @click="tipSort('timestamp')">minute</th>
                                                    <th class="dualHeader1" colspan="1">score</th>
                                                    <th class="dualHeader1" colspan="1" @click="tipSort('bet_status')">bet status</th>
                                                    <th class="dualHeader1" colspan="1">entry min</th>
                                                    <th class="dualHeader1" colspan="1">entry odd</th>
                                                    <th class="dualHeader1" colspan="1">Pot Profit</th>                            
                                                    <th class="dualHeader1" colspan="1">Curr P/L</th>
                                                    <th class="dualHeader1" colspan="1">Open</th>
                                                    <th class="dualHeader1" colspan="1">C/O, P, C</th>
                                                </tr>
                                                
                                                <tr v-for="(item, index) in filtered_pendingTips">
                                                    <td style="padding: 0px">
                                                        <CInputCheckbox class="check-box" :checked.sync = "item.view" @update:checked="tipView(item._id, item.view)" />
                                                    </td>
                                                    <td style="padding: 0px"> {{ item.eventName }}</td>
                                                    <td style="padding: 0px"> {{ item.strategyName }}</td>
                                                    <td style="padding: 0px"> {{ item.type }}</td>
                                                    <td style="padding: 0px"> {{ item.bl }}</td>
                                                    <td style="padding: 0px"> {{ item.predict }}</td>
                                                    <td style="padding: 0px"> {{ item.stake_pt }}</td>
                                                    <td style="padding: 0px"> {{ item.stake_money }}</td>
                                                    <td v-if="item.status == 'LIVE'" style="padding: 0px;"><span style="background-color: red; color: white;"> {{ item.status }}</span></td>
                                                    <td v-else style="padding: 0px;"> {{ item.status }}</td>
                                                    <td style="padding: 0px"> {{ item.minute }}</td>
                                                    <td style="padding: 0px"> {{ item.score }}</td>
                                                    <td v-if="item.bet_status=='unmatched'" style="padding: 0px; color: red;"> {{ item.bet_status }}</td>
                                                    <td v-else-if="item.bet_status=='placed'" style="padding: 0px; color: green;"> {{ item.bet_status }}</td>
                                                    <td v-else-if="item.bet_status=='partial matched'" style="padding: 0px; color: orange;"> {{ item.bet_status }}</td>
                                                    <td v-else style="padding: 0px; color: blue;"> {{ item.bet_status }}</td>
                                                    <td style="padding: 0px"> {{ item.entry_min }}</td>
                                                    <td style="padding: 0px"> {{ item.entry_odd }}</td>
                                                    <td style="padding: 0px"> {{ item.pot_Profit }}</td>
                                                    <td style="padding: 0px"> {{ item.curPL }}</td>
                                                    <!-- <td style="padding: 0px"> <CInputCheckbox class="check-box" :checked.sync = "item.select" /></td> -->
                                                    <td>
                                                        <a v-if="item.com_url"  :href="item.com_url" target="_blank" class="column-league-content-link">
                                                            <img src="/img/bf.com_icon.png" style="margin-top: -2px;" />
                                                        </a>                                            
                                                    
                                                        <a v-if="item.it_url"  :href="item.it_url" target="_blank"  class="column-league-content-link">
                                                            <img src="/img/bf.it_icon_new.png" style="margin-top: -2px;" />
                                                        </a>
                                                    </td>

                                                    <td style="padding: 0px">
                                                        <CButton v-if="!item.instruction" color="info" class="m-2" @click="manualOrder(item)" :disabled="item.marketStatus != 'OPEN'">place</CButton>
                                                        <CButton v-else-if="item.betfairCashouts.length > 0" color="info" class="m-2" disabled="true">cashouted</CButton>
                                                        <CButton v-else-if="item.bet_status == 'unmatched' || item.bet_status == 'partial matched'" color="info" class="m-2" @click="actionDeleteOrder(item.marketId, item.betId)" :disabled="item.marketStatus != 'OPEN'">delete</CButton>
                                                        <CButton v-else color="info" class="m-2" @click="cashOut(item)" :disabled="!item.cashOut || !item.sizeMatched || item.marketStatus != 'OPEN'">cashout{{item.cashOut}} </CButton>
                                                    </td>
                                                </tr>
                                            </table>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCard>
                            <CCard bodyWrapper class="card_background" style="height: 658px;">
                                <div title="Market view">
                                    
                                    <div style="margin-bottom: 5px;">
                                        <span style="color: blue;">Market view</span>
                                    </div>
                                    <div class="market-view">
                                        <div v-for="(item, index) in filtered_marketViews">
                                            <div class="market_header">
                                                {{ item.eventName }}
                                            </div>

                                            <div class="market_header" style="display: flex;">
                                                <span style="flex: 4">marketType: {{ item.betfair_marketType }}</span>
                                                <span style="flex: 3">sections: {{ item.odds.numberOfRunners }}</span>
                                                <span style="flex: 1"  class="back_odd">Back</span>
                                                <span style="flex: 1" class="lay_odd">Lay</span>
                                                <span style="flex: 3"></span>
                                                <span style="flex: 4">matched: {{ item.odds.totalMatched }}</span>
                                            </div>

                                            <div v-if="item.betfair_marketType == 'MATCH_ODDS' && item.api_predictionType.includes('Double chance') === false">
                                                <div class="market_row" style="display: flex;">
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Home - FT
                                                        </span>
                                                        
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[0].selectionId.toString()] }}
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3; color: red; font-weight: bold; font-size: 20px ">{{ item.odds.status }}</span>
                                                    

                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToBack[0].price, 'Home - FT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[0].ex.availableToBack[0].price }}
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            ({{ item.odds.runners[0].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>

                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToLay[0].price, 'Home - FT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[0].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">
                                                            ({{ item.odds.runners[0].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Away - FT
                                                        </span>

                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[1].selectionId.toString()] }}
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToBack.length > 0"  style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToBack[0].price, 'Away - FT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[1].ex.availableToBack[0].price }} 
                                                        </span>
                                                        <span class="bet-button-size" >
                                                            ({{ item.odds.runners[1].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToLay.length > 0"  style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToLay[0].price, 'Away - FT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[1].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Draw - FT
                                                        </span>
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[2].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[2].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[2].selectionId.toString()] }}
                                                        </span>
                                                        
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[2].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[2].selectionId, item.odds.runners[2].ex.availableToBack[0].price, 'Draw - FT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[2].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[2].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[2].ex.availableToLay.length > 0"  style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[2].selectionId, item.odds.runners[2].ex.availableToLay[0].price, 'Draw - FT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[2].ex.availableToLay[0].price }}
                                                            </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[2].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                            </div>

                                            <div v-else-if="item.betfair_marketType == 'HALF_TIME'">
                                                <div class="market_row" style="display: flex;">
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Home - HT
                                                        </span>
                                                        
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[0].selectionId.toString()] }}
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3; color: red; font-weight: bold; font-size: 20px ">{{ item.odds.status }}</span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToBack[0].price, 'Home - HT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[0].ex.availableToBack[0].price }}
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            ({{ item.odds.runners[0].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToLay[0].price, 'Home - HT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[0].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">
                                                            ({{ item.odds.runners[0].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Away - HT
                                                        </span>

                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[1].selectionId.toString()] }}
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToBack[0].price, 'Away - HT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[1].ex.availableToBack[0].price }} 
                                                        </span>
                                                        <span class="bet-button-size" >
                                                            ({{ item.odds.runners[1].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToLay[0].price, 'Away - HT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[1].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Draw - HT
                                                        </span>
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[2].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[2].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[2].selectionId.toString()] }}
                                                        </span>
                                                        
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[2].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[2].selectionId, item.odds.runners[2].ex.availableToBack[0].price, 'Draw - HT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[2].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[2].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[2].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[2].selectionId, item.odds.runners[2].ex.availableToLay[0].price, 'Draw - HT', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[2].ex.availableToLay[0].price }}
                                                            </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[2].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                            </div>

                                            <div v-else-if="item.betfair_marketType.includes('OVER_UNDER_')">
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Under - {{ item.betfair_marketType.split('OVER_UNDER_')[1] }} - FT
                                                        </span>
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[0].selectionId.toString()] }}
                                                        </span>
                                                        
                                                    </div>
                                                    <span style="flex: 3; color: red; font-weight: bold; font-size: 20px ">{{ item.odds.status }}</span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToBack.length > 0"  style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToBack[0].price, 'Under - ' + item.betfair_marketType.split('OVER_UNDER_')[1] + ' - FT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[0].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[0].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToLay[0].price, 'Under - ' + item.betfair_marketType.split('OVER_UNDER_')[1] + ' - FT',  item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[0].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[0].ex.availableToLay[0].size }})
                                                        </span>
                                                     </div>
                                                     <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Over - {{ item.betfair_marketType.split('OVER_UNDER_')[1] }} - FT
                                                        </span>

                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[1].selectionId.toString()] }}
                                                        </span>

                                                        
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToBack[0].price, 'Over - ' + item.betfair_marketType.split('OVER_UNDER_')[1] + ' - FT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[1].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToLay[0].price, 'Over - ' + item.betfair_marketType.split('OVER_UNDER_')[1] + ' - FT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[1].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToLay[0].size }})
                                                        </span>
                                                     </div>
                                                     <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>

                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                            </div>

                                            <div v-else-if="item.betfair_marketType.includes('FIRST_HALF_GOALS_')">
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Under - {{ item.betfair_marketType.split('FIRST_HALF_GOALS_')[1] }} - HT
                                                        </span>
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[0].selectionId.toString()] }}
                                                        </span>
                                                        
                                                    </div>
                                                    <span style="flex: 3; color: red; font-weight: bold; font-size: 20px ">{{ item.odds.status }}</span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToBack[0].price, 'Under - ' + item.betfair_marketType.split('FIRST_HALF_GOALS_')[1] + ' - HT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[0].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[0].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToLay[0].price, 'Under - ' + item.betfair_marketType.split('FIRST_HALF_GOALS_')[1] + ' - HT',  item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[0].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[0].ex.availableToLay[0].size }})
                                                        </span>
                                                     </div>
                                                     <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Over - {{ item.betfair_marketType.split('FIRST_HALF_GOALS_')[1] }} - HT
                                                        </span>

                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[1].selectionId.toString()] }}
                                                        </span>

                                                        
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToBack[0].price, 'Over - ' + item.betfair_marketType.split('FIRST_HALF_GOALS_')[1] + ' - HT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[1].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToLay[0].price, 'Over - ' + item.betfair_marketType.split('FIRST_HALF_GOALS_')[1] + ' - HT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[1].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToLay[0].size }})
                                                        </span>
                                                     </div>
                                                     <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                            </div>

                                            <div v-else-if="item.betfair_marketType.includes('BOTH_TEAMS_TO_SCORE')">
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            BTS - FT
                                                        </span>
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[0].selectionId.toString()] }}
                                                        </span>
                                                        
                                                    </div>
                                                    <span style="flex: 3; color: red; font-weight: bold; font-size: 20px ">{{ item.odds.status }}</span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToBack[0].price, 'BTS - FT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[0].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[0].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToLay[0].price, 'BTS - FT',  item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[0].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[0].ex.availableToLay[0].size }})
                                                        </span>
                                                     </div>
                                                     <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            No BTS - FT
                                                        </span>

                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[1].selectionId.toString()] }}
                                                        </span>

                                                        
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToBack[0].price, 'No BTS - FT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[1].ex.availableToBack[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToLay[0].price, 'No BTS - FT', item.apiId)">
                                                        <span class="bet-button-price">{{ item.odds.runners[1].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToLay[0].size }})
                                                        </span>
                                                     </div>
                                                     <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                            </div>

                                            <div v-else-if="item.betfair_marketType == 'DRAW_NO_BET'">
                                                <div class="market_row" style="display: flex;">
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Home - Draw no bet
                                                        </span>
                                                        
                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[0].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[0].selectionId.toString()] }}
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3; color: red; font-weight: bold; font-size: 20px ">{{ item.odds.status }}</span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToBack[0].price, 'Home - Draw no bet', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[0].ex.availableToBack[0].price }}
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            ({{ item.odds.runners[0].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[0].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[0].selectionId, item.odds.runners[0].ex.availableToLay[0].price, 'Home - Draw no bet', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[0].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">
                                                            ({{ item.odds.runners[0].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>
                                                <div class="market_row" style="display: flex;">
                                                    
                                                    <div style="flex: 4">
                                                        <span class="bet-button-price">
                                                            Away - Draw no bet
                                                        </span>

                                                        <span class="market-total-profit" v-if="marketProfits.filter(market => market.marketId == item.odds.marketId).length > 0 && marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId).length > 0">
                                                            {{ marketProfits.filter(market => market.marketId == item.odds.marketId)[0].profitAndLosses.filter(runner => runner.selectionId == item.odds.runners[1].selectionId)[0].ifWin }}
                                                        </span>

                                                        <span class="market-partial-profit" v-if="runner_profits && runner_profits.marketId == item.odds.marketId">
                                                            {{ runner_profits[item.odds.runners[1].selectionId.toString()] }}
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToBack.length > 0" style="flex: 1" class="back_odd" @click="addBackRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToBack[0].price, 'Away - Draw no bet', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[1].ex.availableToBack[0].price }} 
                                                        </span>
                                                        <span class="bet-button-size" >
                                                            ({{ item.odds.runners[1].ex.availableToBack[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="back_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <div v-if="item.odds.status == 'OPEN' && item.odds.runners[1].ex.availableToLay.length > 0" style="flex: 1" class="lay_odd" @click="addLayRunner(item.odds.marketId, item.odds.runners[1].selectionId, item.odds.runners[1].ex.availableToLay[0].price, 'Away - Draw no bet', item.apiId)">
                                                        <span class="bet-button-price">
                                                            {{ item.odds.runners[1].ex.availableToLay[0].price }}
                                                        </span>
                                                        <span class="bet-button-size">({{ item.odds.runners[1].ex.availableToLay[0].size }})
                                                        </span>
                                                    </div>
                                                    <div v-else style="flex: 1" class="lay_odd_stick">
                                                        <span class="bet-button-price">
                                                            &nbsp;
                                                        </span> 
                                                        <span class="bet-button-size">
                                                            &nbsp;
                                                        </span>
                                                    </div>
                                                    <span style="flex: 3"></span>
                                                    <span style="flex: 4"></span>
                                                </div>                            
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </CCard>
                        </div>
                        <div style="flex: 3;  max-width: 30%;" class="post-tip-container">
                            <CCard bodyWrapper class="bets-table" style="height: 529px;">
                                <div style="margin-bottom: 5px;">
                                    <span style="color: blue;">Matched bets</span>
                                </div>
                                
                                <div v-if="matched_back_runners.length > 0" >
                                    <div class="place_bets" style="display: flex;background-color: #a6d8ff; text-align: center;">
                                        <span style="flex: 3">Back</span>
                                        <span style="flex: 1; text-align: center;">Odds</span>
                                        <span style="flex: 1; text-align: center;">Stake</span>
                                        <span style="flex: 1; text-align: center;">Profit</span>
                                    </div>

                                    <div v-for="(item, index) in matched_back_runners" style="background-color: #dbefff;" class="bet-row">
                                        <div> {{item.eventName }} </div>
                                        <div style="display: flex;">
                                            <span style="flex: 3">
                                                {{ item.predict }}
                                            </span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.averagePriceMatched }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.sizeMatched }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.pot_Profit }}</span>
                                        </div>

                                        
                                    </div>
                                    
                                </div>

                                <div v-if="matched_lay_runners.length > 0" >
                                    <div class="place_bets" style="display: flex; background-color: #fac9d1; ">
                                        <span style="flex: 3; text-align: center;">Lay</span>
                                        <span style="flex: 1; text-align: center;">Odds</span>
                                        <span style="flex: 1; text-align: center;">Stake</span>
                                        <span style="flex: 1; text-align: center;">Liability</span>
                                        <!-- <span style="flex: 1;">
                                            <CInputRadio label="Payout" name="radioGroupName" :checked="layPayout" @update:checked="setLayPayout" />
                                            <CInputRadio label="Liability" name="radioGroupName" :checked="layLiability" @update:checked="setLayLiability" />
                                            
                                        </span> -->
                                    </div>
                                    <div v-for="(item, index) in matched_lay_runners" style="background-color: #feeaee;" class="bet-row">
                                        <div> {{item.eventName }} </div>
                                        <div style="display: flex;">
                                            <span style="flex: 3">
                                                {{ item.predict }}
                                            </span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.averagePriceMatched }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.sizeMatched }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ (item.averagePriceMatched * item.sizeMatched - item.sizeMatched).toFixed(2) }} </span>
                                        </div>
                                    </div>                
                                </div>
                            </CCard> 
                            <CCard bodyWrapper class="bets-table" style="height: 488px;">
                                <div style="margin-bottom: 5px;">
                                    <span style="color: blue;">Place bets</span>
                                </div>
                                <div v-if="oddsErrorMessage">
                                    <p class="error-message__statement">Back odds cannot be less or the same as Lay odds. </p>
                                </div>
                                <div v-if="back_runners.length > 0" >
                                    <div class="place_bets" style="display: flex;background-color: #a6d8ff; text-align: center;">
                                        <span style="flex: 3">Back</span>
                                        <span style="flex: 1; text-align: center;">Odds</span>
                                        <span style="flex: 1; text-align: center;">Stake</span>
                                        <span style="flex: 1; text-align: center;">Profit</span>
                                    </div>
                                    <div v-for="(item, index) in back_runners" style="display: flex;background-color: #dbefff;">
                                        <span style="flex: 3">
                                            <button  style="float:  none;" type="button" aria-label="Close" class="close" @click="deleteBankRunner(item.selectionId )"><span aria-hidden="true">×</span></button>
                                            {{ item.runnerName }}
                                        </span>
                                        <CInput style="flex: 1; text-align: center;margin: auto;"  type="number" :value.sync="item.odds"></CInput>
                                        <CInput style="flex: 1; text-align: center;margin: auto;"  type="number" :value.sync="item.stake"></CInput>
                                        <span style="flex: 1; text-align: center;margin: auto;">{{ (item.odds * item.stake -item.stake).toFixed(2) }}</span>
                                    </div>
                                    
                                </div>

                                <div v-if="lay_runners.length > 0" >
                                    <div class="place_bets" style="display: flex; background-color: #fac9d1; ">
                                        <span style="flex: 3; text-align: center;">Lay</span>
                                        <span style="flex: 1; text-align: center;">Odds</span>
                                        <span style="flex: 1; text-align: center;">Stake</span>
                                        <span style="flex: 1;">
                                            <CInputRadio label="Payout" name="radioGroupName" :checked="layPayout" @update:checked="setLayPayout" />
                                            <CInputRadio label="Liability" name="radioGroupName" :checked="layLiability" @update:checked="setLayLiability" />
                                            
                                        </span>
                                    </div>
                                    <div v-for="(item, index) in lay_runners" style="display: flex; background-color: #feeaee;">
                                        <span style="flex: 3">
                                            <button  style="float:  none;" type="button" aria-label="Close" class="close" @click="deleteLayRunner(item.selectionId )"><span aria-hidden="true">×</span></button>
                                            {{ item.runnerName }}
                                        </span>
                                        <CInput style="flex: 1; text-align: center;margin: auto; "  type="number" :value.sync="item.odds"></CInput>
                                        <CInput style="flex: 1; text-align: center;margin: auto; "  type="number" :value.sync="item.stake"></CInput>
                                        <span v-if="layPayout" style="flex: 1; text-align: center;margin: auto;">{{ (item.odds * item.stake).toFixed(2) }}</span>
                                        <span v-else style="flex: 1; text-align: center;margin: auto;">{{ (item.odds * item.stake - item.stake).toFixed(2) }}</span>
                                    </div>
                                    
                                </div>

                                <div v-if="back_runners.length > 0 || lay_runners.length > 0">
                                    <div style="padding-top: 30px; text-align: right;">Liability: {{total_liability}}</div>
                                    <CButton color="info" class="m-2" @click="deleteAllBets()">Cancel all selections</CButton>
                                    <CButton color="info" class="m-2" @click="placeBets()" :disabled="oddsErrorMessage || total_liability == '' ">Place bets</CButton></td>
                                </div>
                            </CCard>

                            <CCard bodyWrapper class="bets-table" style="height: 658px;">
                                <div style="margin-bottom: 5px;">
                                    <span style="color: blue;">Unmatched bets</span>
                                </div>
                                
                                <div v-if="unmatched_back_runners.length > 0" >
                                    <div class="place_bets" style="display: flex;background-color: #a6d8ff; text-align: center;">
                                        <span style="flex: 3">Back</span>
                                        <span style="flex: 1; text-align: center;">Odds</span>
                                        <span style="flex: 1; text-align: center;">Stake</span>
                                        <span style="flex: 1; text-align: center;">Profit</span>
                                    </div>

                                    <div v-for="(item, index) in unmatched_back_runners" style="background-color: #dbefff;" class="bet-row">
                                        <div> {{item.eventName }} </div>
                                        <div style="display: flex;">
                                            <span style="flex: 3">
                                                {{ item.predict }}
                                            </span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.instruction.limitOrder.price }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.sizeRemaining }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.sizeRemaining }}</span>
                                        </div>
                                        <div>
                                            <CButton color="info" class="m-2" @click="actionDeleteOrder(item.marketId, item.betId)">Cancel unmatched</CButton>
                                            <CButton color="info" class="m-2" @click="actionUpdateOrder(item.marketId, item.betId)" :disabled="item.instruction.limitOrder.persistenceType == 'PERSIST'">Update</CButton>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div v-if="unmatched_lay_runners.length > 0" >
                                    <div class="place_bets" style="display: flex; background-color: #fac9d1; ">
                                        <span style="flex: 3; text-align: center;">Lay</span>
                                        <span style="flex: 1; text-align: center;">Odds</span>
                                        <span style="flex: 1; text-align: center;">Stake</span>
                                        <span style="flex: 1; text-align: center;">Liability</span>
                                        <!-- <span style="flex: 1;">
                                            <CInputRadio label="Payout" name="radioGroupName" :checked="layPayout" @update:checked="setLayPayout" />
                                            <CInputRadio label="Liability" name="radioGroupName" :checked="layLiability" @update:checked="setLayLiability" />
                                            
                                        </span> -->
                                    </div>
                                    <div v-for="(item, index) in unmatched_lay_runners" style="background-color: #feeaee;" class="bet-row">
                                        <div> {{item.eventName }} </div>
                                        <div style="display: flex;">
                                            <span style="flex: 3">
                                                {{ item.predict }}
                                            </span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.instruction.limitOrder.price }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ item.sizeRemaining }}</span>
                                            <span style="flex: 1; text-align: center;margin: auto;">  {{ (item.instruction.limitOrder.price * item.sizeRemaining - item.sizeRemaining).toFixed(2) }}</span>
                                        </div>
                                        <div>
                                            <CButton color="info" class="m-2" @click="actionDeleteOrder(item.marketId, item.betId)">Cancel unmatched</CButton>
                                            <CButton color="info" class="m-2" @click="actionUpdateOrder(item.marketId, item.betId)" :disabled="item.instruction.limitOrder.persistenceType == 'PERSIST'">Update</CButton>
                                        </div>
                                    </div>                
                                </div>
                            </CCard>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import { CFormCheck } from '@coreui/vue';
    import Swal from 'sweetalert2';

    import {displaySuccess, displayError} from '../helpers/message';
    import {convertUTCToLocal, defaultFormat} from '@/helpers/time';

    export default {
        name: 'PostTip',
        components: {
            Multiselect,
            CFormCheck
        },
        data () {
            return {
                betfair_user: "",
                betfair_password: "",
                betfair_authcode_required: false,
                betfair_authcode: "",
                betfairLoggedIn: false,
                betfairLoggedIn_loading: true,

                myStrategies: [],
                pendingTips: [],
                marketViews: [],
                loading: false,
                betfair_setting: {
                    budget: '',
                    flat_stake: '',
                    leverage: '',
                    max_esposure: '',
                    stop_loss: '',
                    max_tips: '',
                    lay_stake: "payout",
                    swap: false,
                    take_tip_odd_price: false,
                    take_tip_published_odd_price: false,
                    keep_bet: false,
                    take_otherside_odd_price: false,

                    size_percent: '',
                    max_esposure_per_bet: '',
                    stop_loss_daily: '',
                    target_profit: '',
                    stop_after_target_profit: false,
                    max_tips_matched: '',
                    auto_cashout: false,
                    free_bet: false,
                    bet_again: false
                },
                lay_stake_Options: [                    
                    "payout",
                    "liability"                    
                ],
                back_runners: [],
                lay_runners: [],
                layPayout: true,
                layLiability: false,
                marketProfits: [],
                myStrategyKey: 0,
                tips_filter: {
                    strategyName: 0,
                    status: 0,
                    bet_status: 0,
                    timestamp  : 0
                }
            }
        },
        computed: {
            ...mapGetters(['loggedInUser']),

            filtered_pendingTips() {
                
                let viewed_strategies = [];
                for (var i=0; i<this.myStrategies.length; i++) {
                    if (this.myStrategies[i].view && this.myStrategies[i].play_stop)
                        viewed_strategies.push(this.myStrategies[i]._id);
                }

                let result = this.pendingTips.filter( item => viewed_strategies.includes(item.strategyId) || item.strategyId == null );

                for (const param of Object.keys(this.tips_filter)) {                    
                    if ( this.tips_filter[param] == 1 ) {
                        this.sortJSON1(result, param);
                        break;
                    }
                    else if ( this.tips_filter[param] == -1 ) {
                        this.sortJSON2(result, param);
                        break;
                    }
                }

                return result;

            },
            myStrategies_active() {
                let result = this.myStrategies.filter( item => item.betfair_status === true );
                return result;
            },
            myStrategies_archived() {
                let result = this.myStrategies.filter( item => item.betfair_status === false );
                return result;
            },
            filtered_marketViews() {
                let result = [];
                let marketIds = [];
                for ( var i=0; i<this.filtered_pendingTips.length; i++ ){
                    if (!this.filtered_pendingTips[i].view)
                        continue;
                    let betfairId = this.filtered_pendingTips[i].betfairId;
                    let api_predictionType = this.filtered_pendingTips[i].predict;
                    let betfair_marketType;
                    if ( api_predictionType == "Home - FT" || api_predictionType == "Draw - FT" || api_predictionType == "Away - FT"  )
                        betfair_marketType = 'MATCH_ODDS';
                    else if ( api_predictionType == 'Over - 0.5 - FT' || api_predictionType == 'Under - 0.5 - FT' )
                        betfair_marketType = 'OVER_UNDER_05';
                    else if ( api_predictionType == 'Over - 1.5 - FT' || api_predictionType == 'Under - 1.5 - FT' )
                        betfair_marketType = 'OVER_UNDER_15';
                    else if ( api_predictionType == 'Over - 2.5 - FT' || api_predictionType == 'Under - 2.5 - FT' )
                        betfair_marketType = 'OVER_UNDER_25';
                    else if ( api_predictionType == 'Over - 3.5 - FT' || api_predictionType == 'Under - 3.5 - FT' )
                        betfair_marketType = 'OVER_UNDER_35';
                    else if ( api_predictionType == 'Over - 4.5 - FT' || api_predictionType == 'Under - 4.5 - FT' )
                        betfair_marketType = 'OVER_UNDER_45';

                    else if ( api_predictionType == 'BTS - FT' || api_predictionType == 'No BTS - FT' )
                        betfair_marketType = 'BOTH_TEAMS_TO_SCORE';

                    else if ( api_predictionType == "Home - HT" || api_predictionType == "Draw - HT" || api_predictionType == "Away - HT"  )
                        betfair_marketType = 'HALF_TIME';

                    else if ( api_predictionType == 'Over - 0.5 - HT' || api_predictionType == 'Under - 0.5 - HT' )
                        betfair_marketType = 'FIRST_HALF_GOALS_05';
                    else if ( api_predictionType == 'Over - 1.5 - HT' || api_predictionType == 'Under - 1.5 - HT' )
                        betfair_marketType = 'FIRST_HALF_GOALS_15';
                    else if ( api_predictionType == 'Over - 2.5 - HT' || api_predictionType == 'Under - 2.5 - HT' )
                        betfair_marketType = 'FIRST_HALF_GOALS_25';        

                    else if ( api_predictionType == 'Home - Draw no bet' || api_predictionType == 'Away - Draw no bet' )
                        betfair_marketType = 'DRAW_NO_BET';

                    else if ( api_predictionType == "1X - Double chance" || api_predictionType == "X2 - Double chance" || api_predictionType == "12 - Double chance"  )
                        betfair_marketType = 'MATCH_ODDS';
                    
                    if (betfair_marketType) {
                        let betfair_events = this.marketViews.filter( item=> item.betfairId == betfairId);
                        let betfair_event = betfair_events[0];
                        let odds = betfair_event[betfair_marketType];
                        // if (odds.runners && odds.runners.length > 0 && odds.runners[0].ex.availableToLay.length > 0 && odds.runners[0].ex.availableToBack.length > 0) {
                        if (odds && odds.runners) {
                            if ( !marketIds.includes(odds.marketId) ) {
                                result.push({
                                    apiId: betfair_event.apiId,
                                    betfairId: betfair_event.betfairId,
                                    eventName: betfair_event.eventName,
                                    openDate: betfair_event.openDate,
                                    api_predictionType: api_predictionType,
                                    betfair_marketType: betfair_marketType,
                                    odds: odds
                                });

                                marketIds.push(odds.marketId)
                            }
                            
                        }
                    }
                }                
                return result;
            },
            total_liability() {

                let total_liability = 0;
                let max_lay = null;
                if (this.lay_runners.length > 0) {

                    if (this.layPayout){
                        max_lay = this.lay_runners.reduce(function(prev, current) {
                            return ((prev.odds * prev.stake) >= (current.odds * current.stake)) ? prev : current;
                        });
                    }
                    else {
                        max_lay = this.lay_runners.reduce(function(prev, current) {
                            return ((prev.odds * prev.stake - prev.stake) >= (current.odds * current.stake - current.stake)) ? prev : current;
                        });
                    }

                    if (max_lay && max_lay.stake == '')
                        max_lay = null;
                }

                let back_runners = this.back_runners.filter( item => item.stake);
                let back_stakes = back_runners.map(({ stake }) => parseFloat(stake));
                let sum = back_stakes.reduce((partialSum, a) => partialSum + a, 0);

                if (!max_lay) {
                    
                    if (back_stakes.length == 3) {
                        total_liability =  sum - Math.min(...back_stakes);
                    }
                    else
                        total_liability =  sum;
                }
                else {
                    back_runners = this.back_runners.filter( item => item.selectionId != max_lay.selectionId && item.stake);
                    back_stakes = back_runners.map(({ stake }) => parseFloat(stake));
                    sum = back_stakes.reduce((partialSum, a) => partialSum + a, 0);
                    total_liability = sum + max_lay.stake * max_lay.odds - max_lay.stake;
                }
                return total_liability; 
            },
            runner_profits() {
                let runner_profits = null;
                let marketId = null;
                if ( this.back_runners.length > 0 ) {
                    marketId = this.back_runners[0].marketId;
                }
                else if ( this.lay_runners.length > 0 ) {
                    marketId = this.lay_runners[0].marketId;
                }
                
                if (marketId) {
                    let selected_market = this.filtered_marketViews.filter( item => item.odds.marketId == marketId);
                    if (selected_market.length > 0) {
                        let runner_ids = selected_market[0].odds.runners.map(({ selectionId }) => selectionId);

                        runner_profits = {
                            marketId: marketId
                        };

                        for ( var i=0; i<runner_ids.length; i++) {
                            runner_profits[runner_ids[i].toString()] = 0;
                        }

                        let runner;
                        let this_runnerId;
                        for ( var i=0; i<this.back_runners.length; i++) {
                            runner = this.back_runners[i];
                            this_runnerId = runner.selectionId;

                            runner_profits[this_runnerId.toString()] += runner.odds * runner.stake - runner.stake;
                            for ( var j=0; j<runner_ids.length; j++ ){
                                if (this_runnerId != runner_ids[j]) {
                                    runner_profits[runner_ids[j].toString()] -= runner.stake * 1;
                                }
                            }
                        }

                        for ( var i=0; i<this.lay_runners.length; i++) {
                            runner = this.lay_runners[i];
                            this_runnerId = runner.selectionId;
                            if (this.layPayout) {
                                runner_profits[this_runnerId.toString()] -= runner.odds * runner.stake;
                            }
                            else
                                runner_profits[this_runnerId.toString()] -= runner.odds * runner.stake - runner.stake;
                            for ( var j=0; j<runner_ids.length; j++ ){
                                if (this_runnerId != runner_ids[j]) {
                                    runner_profits[runner_ids[j].toString()] += runner.stake * 1;
                                }
                            }
                        }
                    }
                }
                return runner_profits;
            },
            oddsErrorMessage() {
                let errorFlag = false;
                for (var i = 0; i < this.back_runners.length; i++) {
                    let back_runner = this.back_runners[i];

                    for (var j = 0; j < this.lay_runners.length; j++) {
                        let lay_runner = this.lay_runners[j];
                        if (back_runner.selectionId == lay_runner.selectionId) {
                            if (back_runner.stake && lay_runner.stake && parseFloat(back_runner.odds) <= parseFloat(lay_runner.odds)){
                                errorFlag = true;
                                break;
                            }
                        }
                        
                    }
                    if (errorFlag)
                        break;
                }
                return errorFlag;
            },
            matched_back_runners() {
                let runners = this.pendingTips.filter( item => item.betfairSettled === 0 && item.bl === "BACK" && item.sizeMatched > 0);
                return runners;
            },
            matched_lay_runners() {
                let runners = this.pendingTips.filter( item => item.betfairSettled === 0 && item.bl === "LAY" && item.sizeMatched > 0);
                return runners;
            },
            unmatched_back_runners() {
                let runners = this.pendingTips.filter( item => item.betfairSettled === 0 && item.bl === "BACK" && item.sizeRemaining);
                
                for ( var i=0; i<this.pendingTips.length; i++) {
                    let this_tip = this.pendingTips[i];
                    for ( var j=0; j < this_tip.betfairCashouts.length; j++) {
                        let this_cashout = this_tip.betfairCashouts[j];
                        if (this_cashout.sizeRemaining && this_cashout.instruction.side == "BACK") {
                            runners.push({
                                eventName: this_tip.eventName,
                                predict: this_cashout.predictionType,
                                instruction: this_cashout.instruction,
                                marketId: this_cashout.marketId,
                                betId: this_cashout.betId,
                                sizeRemaining: this_cashout.sizeRemaining,
                                // pot_Profit: (this_cashout.instruction.limitOrder.price * this_cashout.instruction.limitOrder.size - this_cashout.instruction.limitOrder.size).toFixed(2)
                                pot_Profit: (this_cashout.instruction.limitOrder.price * this_cashout.sizeRemaining - this_cashout.sizeRemaining).toFixed(2)
                            });
                        }
                    }
                }
                return runners;
            },
            unmatched_lay_runners() {
                let runners = this.pendingTips.filter( item => item.betfairSettled === 0 && item.bl === "LAY" && item.sizeRemaining);
                for ( var i=0; i<this.pendingTips.length; i++) {
                    let this_tip = this.pendingTips[i];
                    for ( var j=0; j < this_tip.betfairCashouts.length; j++) {
                        let this_cashout = this_tip.betfairCashouts[j];
                        if (this_cashout.sizeRemaining && this_cashout.instruction.side == "LAY") {
                            runners.push({
                                eventName: this_tip.eventName,
                                predict: this_cashout.predictionType,
                                instruction: this_cashout.instruction,
                                marketId: this_cashout.marketId,
                                betId: this_cashout.betId,
                                sizeRemaining: this_cashout.sizeRemaining,
                                // pot_Profit:  this_cashout.instruction.limitOrder.size.toFixed(2)
                                pot_Profit:  this_cashout.sizeRemaining.toFixed(2)
                            });
                        }
                    }
                }
                return runners;
            },
        },
        methods: {
            ...mapActions([
                'getMyStrategies',
                'deleteMyStrategy',
                'setPlayStrategy',
                'setAutoStrategy',
                'setBetfairStrategy',
                'setStrategyView',
                'setTipView',
                'placeOrders',
                'betfairCashout',
                'deleteOrder',
                'updateOrder',
                'resetStrategyStats',

                'betfairlogin',
                'betfairlogout',
                'checkBetfairLogin'

            ]),
            check_BetfairLogin() {
                this.checkBetfairLogin().then((data) => {
                    if ( data.status == 'login' ) {
                        this.betfairLoggedIn = true;
                    }
                    else {
                        this.betfairLoggedIn = false;
                    }
                    }).finally(() => {
                        this.betfairLoggedIn_loading =false;
                    console.log('final');
                });
            },
            betfair_login() {
                let password = this.betfair_password;
                if (this.betfair_authcode_required && this.betfair_authcode) {
                    password += this.betfair_authcode;
                }
                let params = {
                    username: this.betfair_user,
                    password: password
                };

                this.betfairlogin(params).then((data) => {
                    console.log("betfair login =>>>>>>>>>>>>>", data);
                    if ( data.status == 'success' ) {
                        Swal.fire("Success!", "Betfair Log in successfully", "success");
                        this.betfairLoggedIn = true;
                    }
                    else if ( data.status == "error" && data.data.error == "STRONG_AUTH_CODE_REQUIRED") {
                        this.betfair_authcode_required = true;
                        Swal.fire("Auth code required!", "Please check auth code", "error");

                    }
                    else if ( data.status == "error" && data.data.error == "INVALID_USERNAME_OR_PASSWORD") {
                        
                        Swal.fire("Login Failed!", "Invalid user or password", "error");

                    }
                    else if ( data.status == "error" && data.data.error == "SUSPENDED ") {                        
                        Swal.fire("Login Failed!", "The account has been suspended!", "error");
                    }
                    else if ( data.status == "error" && data.data.error == "MULTIPLE_USERS_WITH_SAME_CREDENTIAL ") {                        
                        Swal.fire("Login Failed!", "MULTIPLE_USERS_WITH_SAME_CREDENTIAL", "error");
                    }
                    else if ( data.status == "error" && data.data.error == "CLOSED   ") {                        
                        Swal.fire("Login Failed!", "The account has been closed!", "error");
                    }
                    else {
                        Swal.fire("Login Failed!", data.data.error, "error");
                    }
                }).finally(() => {
                    console.log('final');
                });

            },
            betfair_logout() {
                this.betfairlogout().then((data) => {
                    
                    if ( data.status == 'success' ) {
                        Swal.fire("Success!", "Betfair Log out successfully", "success");
                        this.betfairLoggedIn = false;
                    }                    
                    else  {                        
                        Swal.fire("Logout Failed!", "Something went wrong", "error");
                    }
                }).finally(() => {
                    console.log('final');
                });
            },
            setLayPayout(val){
                console.log('layPayout', val)
                this.layPayout = val;
                this.layLiability = !val;
            },
            setLayLiability(val){
                console.log('layLiability', val)
                this.layLiability = val;
                this.layPayout = !val;
            },
            modal_setFields(betfair_setting) {
                // if (betfair_setting) {
                //     this.betfair_setting = betfair_setting;
                // }
                // else {
                //     this.betfair_setting = {
                //         budget: '',
                //         flat_stake: '',
                //         leverage: '',
                //         max_esposure: '',
                //         stop_loss: '',
                //         max_tips: '',
                //         lay_stake: ''
                //     };
                // }
                let default_setting = {
                    budget: '',
                    flat_stake: '',
                    leverage: '',
                    max_esposure: '',
                    stop_loss: '',
                    max_tips: '',
                    lay_stake: "payout",
                    swap: false,
                    take_tip_odd_price: false,
                    take_tip_published_odd_price: false,
                    keep_bet: false,
                    take_otherside_odd_price: false,

                    size_percent: '',
                    max_esposure_per_bet: '',
                    stop_loss_daily: '',
                    target_profit: '',
                    stop_after_target_profit: false,
                    max_tips_matched: '',
                    auto_cashout: false,
                    free_bet: false,
                    bet_again: false
                };
                
                this.betfair_setting = {
                    ...default_setting,
                    ...betfair_setting
                }
                if ( !this.betfair_setting.lay_stake )
                    this.betfair_setting.lay_stake = "payout";
                
            },
            handleOk(bvModalEvt, _id) {
                console.log(bvModalEvt, _id)
                bvModalEvt.preventDefault()

                this.setBetfairStrategy({_id: _id, betfair_setting: this.betfair_setting}).then((data) => {
                    displaySuccess({message: "Successfully Saved strategy setting"});
                    let index = this.myStrategies.findIndex( item => item._id == _id);
                    this.myStrategies[index].betfair_setting = this.betfair_setting;

                }).finally(() => {
                    this.$nextTick(() => {
                        this.$bvModal.hide(_id)
                    })
                });
            },           
            getStrategies() {
                this.getMyStrategies().then(({data}) => {
                    
                    let strategies = data[0];
                    let tips = data[1];

                    let myStrategies = [];
                    let pendingTips = [];
                    let marketViews = [];

                    let betfair_ids = [];
                    for (var i=0; i<strategies.length; i++) {
                        let strategyId = strategies[i]._id.toString();
                        let filteredStrategy = this.myStrategies.filter( item => item._id == strategyId);
                        let strategyView = false;
                        let strategySelect = false;
                        if (filteredStrategy.length > 0) {
                            // strategyView = filteredStrategy[0].view;
                            strategySelect = filteredStrategy[0].select;
                            strategyView = filteredStrategy[0].view;
                        }
                        else {
                            if (strategies[i].view)
                                strategyView = true;
                        }
                        

                        let roi =  (strategies[i].stats.stakeTotal && strategies[i].stats.profitPTS) ? (strategies[i].stats.profitPTS / strategies[i].stats.stakeTotal * 100).toFixed(2) : 0;
                        let pl = strategies[i].stats.profitPTS ? strategies[i].stats.profitPTS.toFixed(2) : 0;
                        let winRate = (strategies[i].stats.loseCount + strategies[i].stats.winCount) ? ((strategies[i].stats.winCount / (strategies[i].stats.loseCount + strategies[i].stats.winCount)) * 100).toFixed(2) : 0;

                        let staked = strategies[i].stats.stakeTotal ? strategies[i].stats.stakeTotal : 0;

                        // let strategy_pendingTips = this.pendingTips.filter( item => item.strategyId == strategies[i]._id.toString());
                        let strategy_curPL  = 0;
                        // strategy_pendingTips.forEach(sItem => {
                        //     strategy_curPL += sItem.curPL;
                        // });

                        let pending_stakeTotal = strategies[i].stats.pending_stakeTotal ? (strategies[i].stats.pending_stakeTotal).toFixed(2) : 0;

                        let item = {
                            _id: strategies[i]._id.toString(),
                            view: strategyView,
                            strategyName: strategies[i].name,
                            userName: strategies[i].users[0].alias,
                            winRate: winRate,
                            roi: roi,
                            pl: pl,
                            pendingTips: strategies[i].stats.pendingCount,
                            pendingMatchedTips: strategies[i].stats.pendings_matchedCount,
                            totalTips: strategies[i].stats.totalCount,
                            play_stop: strategies[i].betfair_play,
                            staked: staked,
                            curPL: strategy_curPL,
                            select: false,
                            auto: strategies[i].betfair_auto,
                            betfair_setting: strategies[i].betfair_setting,
                            betfair_status: strategies[i].betfair_status,
                            pending_stakeTotal: pending_stakeTotal
                        };
                        if (strategies[i].betfair_play) {
                            item.play_stop = strategies[i].betfair_play;
                        }
                        if (strategies[i].betfair_auto) {
                            item.auto = strategies[i].betfair_auto;
                        }
                        myStrategies.push(item);
                    }
                    for (var i=0; i<tips.length; i++) {
                        if (tips[i].betfairEvents.length == 0)
                            continue;

                        if (tips[i].DailyFixtures.length == 0)
                            continue;

                        if (tips[i].DailyFixtures[0].time.status == "FT")
                            continue;

                        let strategy = myStrategies.filter( stra_item => stra_item._id === tips[i].strategy);
                        
                        let side = "BACK";
                        let stake = tips[i].stake;
                        let stake_money = "";
                        let entry_min = "";
                        let entry_odd = "";
                        let pot_Profit = "";
                        let api_predictionType = tips[i].predictionType;
                        let cashOut;
                        let currentPointProfit = 0;
                        let viceOdds;
                        let marketStatus;

                        if ( api_predictionType == "1X - Double chance" || api_predictionType == "X2 - Double chance" || api_predictionType == "12 - Double chance"  ){                            

                            if ( api_predictionType == "1X - Double chance" ) {
                                api_predictionType = "Away - FT";

                            }
                            else if ( api_predictionType == "X2 - Double chance" ) {
                                api_predictionType = "Home - FT";
                                
                            }
                            else if ( api_predictionType == "12 - Double chance" ) {
                                api_predictionType = "Draw - FT";
                                
                            }
                            side = "LAY";
                        }

                        let betfair_marketType;
                        if ( api_predictionType == "Home - FT" || api_predictionType == "Draw - FT" || api_predictionType == "Away - FT"  )
                            betfair_marketType = 'MATCH_ODDS';
                        else if ( api_predictionType == 'Over - 0.5 - FT' || api_predictionType == 'Under - 0.5 - FT' )
                            betfair_marketType = 'OVER_UNDER_05';
                        else if ( api_predictionType == 'Over - 1.5 - FT' || api_predictionType == 'Under - 1.5 - FT' )
                            betfair_marketType = 'OVER_UNDER_15';
                        else if ( api_predictionType == 'Over - 2.5 - FT' || api_predictionType == 'Under - 2.5 - FT' )
                            betfair_marketType = 'OVER_UNDER_25';
                        else if ( api_predictionType == 'Over - 3.5 - FT' || api_predictionType == 'Under - 3.5 - FT' )
                            betfair_marketType = 'OVER_UNDER_35';
                        else if ( api_predictionType == 'Over - 4.5 - FT' || api_predictionType == 'Under - 4.5 - FT' )
                            betfair_marketType = 'OVER_UNDER_45';

                        else if ( api_predictionType == 'BTS - FT' || api_predictionType == 'No BTS - FT' )
                            betfair_marketType = 'BOTH_TEAMS_TO_SCORE';

                        else if ( api_predictionType == "Home - HT" || api_predictionType == "Draw - HT" || api_predictionType == "Away - HT"  )
                            betfair_marketType = 'HALF_TIME';

                        else if ( api_predictionType == 'Over - 0.5 - HT' || api_predictionType == 'Under - 0.5 - HT' )
                            betfair_marketType = 'FIRST_HALF_GOALS_05';
                        else if ( api_predictionType == 'Over - 1.5 - HT' || api_predictionType == 'Under - 1.5 - HT' )
                            betfair_marketType = 'FIRST_HALF_GOALS_15';
                        else if ( api_predictionType == 'Over - 2.5 - HT' || api_predictionType == 'Under - 2.5 - HT' )
                            betfair_marketType = 'FIRST_HALF_GOALS_25';        

                        else if ( api_predictionType == 'Home - Draw no bet' || api_predictionType == 'Away - Draw no bet' )
                            betfair_marketType = 'DRAW_NO_BET';

                        else if ( api_predictionType == "1X - Double chance" || api_predictionType == "X2 - Double chance" || api_predictionType == "12 - Double chance"  ){
                            betfair_marketType = 'MATCH_ODDS';

                            if ( api_predictionType == "1X - Double chance" ) {
                                api_predictionType = "Away - FT";

                            }
                            else if ( api_predictionType == "X2 - Double chance" ) {
                                api_predictionType = "Home - FT";
                                
                            }
                            else if ( api_predictionType == "12 - Double chance" ) {
                                api_predictionType = "Draw - FT";
                                
                            }
                            side = "LAY";
                        }

                        if ( tips[i].instruction){
                            side  = tips[i].instruction.side;
                            
                            // stake_money = tips[i].instruction.limitOrder.size;
                            stake_money = tips[i].sizeMatched;
                            entry_min = tips[i].minAtBet;
                            // entry_odd = tips[i].instruction.limitOrder.price;
                            entry_odd = tips[i].averagePriceMatched;
                            
                            let runner;
                            if (betfair_marketType) {
                                let betfair_event = tips[i].betfairEvents[0];
                                if (betfair_event[betfair_marketType]){
                                    let odds = betfair_event[betfair_marketType];
                                    marketStatus = odds.status;
                                    
                                    if (betfair_marketType == "MATCH_ODDS") {
                                        if ( api_predictionType == "Home - FT" ) {
                                            runner = odds.runners[0];
                                            
                                        }
                                        else if ( api_predictionType == "Away - FT" ) {
                                            runner = odds.runners[1];
                                            
                                        }
                                        else if ( api_predictionType == "Draw - FT" ) {
                                            runner = odds.runners[2];
                                        }
                                        
                                    }

                                    else if (betfair_marketType.includes("OVER_UNDER_")) {
                                        if ( api_predictionType.includes("Under") ) {
                                            runner = odds.runners[0];
                                        }
                                        else if ( api_predictionType.includes("Over") ) {
                                            runner = odds.runners[1];
                                        }
                                    }

                                    else if (betfair_marketType == "BOTH_TEAMS_TO_SCORE") {
                                        if ( api_predictionType == "BTS - FT" ) {
                                            runner = odds.runners[0];
                                        }
                                        else if ( api_predictionType == "No BTS - FT" ) {
                                            runner = odds.runners[1];
                                        }
                                    }

                                    else if (betfair_marketType == "HALF_TIME") {
                                        if ( api_predictionType == "Home - HT" ) {
                                            runner = odds.runners[0];
                                            
                                        }
                                        else if ( api_predictionType == "Away - HT" ) {
                                            runner = odds.runners[1];
                                            
                                        }
                                        else if ( api_predictionType == "Draw - HT" ) {
                                            runner = odds.runners[2];
                                        }
                                        
                                    }
                                    else if (betfair_marketType.includes("FIRST_HALF_GOALS_")) {
                                        if ( api_predictionType.includes("Under") ) {
                                            runner = odds.runners[0];
                                        }
                                        else if ( api_predictionType.includes("Over") ) {
                                            runner = odds.runners[1];
                                        }
                                        
                                    }

                                    else if (betfair_marketType == "DRAW_NO_BET") {
                                        if ( api_predictionType == "Home - Draw no bet" ) {
                                            runner = odds.runners[0];
                                        }
                                        else if ( api_predictionType == "Away - Draw no bet" ) {
                                            runner = odds.runners[1];
                                        }
                                    }

                                }
                            }

                            
                            if (side == "BACK") {
                                pot_Profit = (entry_odd * stake_money - stake_money).toFixed(2);

                                if (runner && runner.ex["availableToLay"].length > 0) {
                                    viceOdds = runner.ex["availableToLay"][0].price;

                                    cashOut = parseFloat((entry_odd * stake_money / viceOdds).toFixed(2));
                                    currentPointProfit = parseFloat((cashOut - stake_money).toFixed(2));
                                }

                                if ( tips[i].betfairCashouts.length > 0 ) {
                                    currentPointProfit = parseFloat(( tips[i].betfairCashouts[0].sizeMatched - stake_money ).toFixed(2));
                                }
                            }
                            else {
                                let betTargetType = tips[i].instruction.limitOrder.betTargetType;
                                if (betTargetType == "PAYOUT") {
                                    // pot_Profit = (entry_odd * stake_money).toFixed(2);
                                    pot_Profit = stake_money;
                                }
                                else {
                                    // pot_Profit = (entry_odd * stake_money - stake_money).toFixed(2);
                                    pot_Profit = stake_money;
                                }

                                if (runner && runner.ex["availableToBack"].length > 0) {
                                    viceOdds = runner.ex["availableToBack"][0].price;
                                    cashOut = parseFloat((entry_odd * stake_money / viceOdds).toFixed(2));
                                    currentPointProfit = parseFloat((stake_money - cashOut).toFixed(2));
                                }

                                if ( tips[i].betfairCashouts.length > 0 ) {
                                    currentPointProfit = parseFloat((stake_money - tips[i].betfairCashouts[0].sizeMatched).toFixed(2));
                                }
                            }
                            
                        }
                        else if ( strategy.length > 0 && strategy[0].betfair_setting ) {
                            if ( strategy[0].betfair_setting.flat_stake ) {
                                stake_money = strategy[0].betfair_setting.flat_stake;
                            }
                            else if ( strategy[0].betfair_setting.leverage ) {
                                stake_money = stake * strategy[0].betfair_setting.leverage;
                            }
                            else if ( strategy[0].betfair_setting.budget && strategy[0].betfair_setting.size_percent ) {
                                let total_pl = strategy[0].pl ? strategy[0].pl : 0;
                                stake_money = (( parseFloat(strategy[0].betfair_setting.budget) + parseFloat(total_pl) ) * parseFloat(strategy[0].betfair_setting.size_percent) / 100 ).toFixed(2);
                            }

                            if ( strategy[0].betfair_setting.swap ) {
                                if ( side == "BACK" )
                                    side = "LAY";
                                else
                                    side = "BACK";
                            }
                        }

                        if (betfair_marketType){
                            if (tips[i].betfairEvents[0][betfair_marketType]){                                
                                marketStatus = tips[i].betfairEvents[0][betfair_marketType].status;
                            }
                        }
                        
                                
                        let strategyName = "";
                        if ( strategy.length > 0 ) {                            
                            strategyName = strategy[0].strategyName;
                        }

                        let filteredTip = this.pendingTips.filter( item => item._id == tips[i]._id);
                        let tipView = false;
                        let tipSelect = false;
                        if (filteredTip.length > 0) {
                            // tipView = filteredTip[0].view;
                            tipSelect = filteredTip[0].select;
                            tipView = filteredTip[0].view;
                        }
                        else {
                            if (tips[i].view)
                                tipView = true;
                        }                        

                        let bet_status = "to confirm";
                        if ( tips[i].betfairSettled === 0 && ( tips[i].sizeMatched === 0 && tips[i].sizeRemaining ) )
                            bet_status = "unmatched";
                        else if ( tips[i].betfairSettled === 0 && ( tips[i].sizeMatched > 0 && tips[i].sizeRemaining ) )
                            bet_status = "partial matched";
                        else if ( tips[i].betfairSettled === 0 && tips[i].sizeMatched > 0 && !tips[i].sizeRemaining)
                            bet_status = "placed";

                        let dateTime = convertUTCToLocal(tips[i].DailyFixtures[0].time.starting_at.date_time);

                        let com_url = 'https://www.betfair.com/exchange/plus/en/football/'
                        let it_url = ''
                        
                        if(tips[i].dailyApiEvents1.length > 0 && tips[i].dailyApiEvents1[0].com_link){
                           
                            let com_name = tips[i].dailyApiEvents1[0].com_link.competitionName
                            let eventN = tips[i].dailyApiEvents1[0].com_link.eventName
                            com_name = com_name.toLowerCase()
                            com_name = com_name.replaceAll(" ", "-")
                            eventN = eventN.toLowerCase()
                            eventN = eventN.replaceAll(" ", "-")
                            com_url = com_name + "/" + eventN
                            com_url = 'https://www.betfair.com/exchange/plus/en/football/' + com_url + '-betting-' + tips[i].dailyApiEvents1[0].com_link.eventId
                        }
                        if(tips[i].dailyApiEvents1.length > 0 && tips[i].dailyApiEvents1[0].it_link){
                        
                            let it_name = tips[i].dailyApiEvents1[0].it_link.competitionName
                            let itN = tips[i].dailyApiEvents1[0].it_link.eventName
                            it_name = it_name.toLowerCase()
                            it_name = it_name.replaceAll(" ", "")
                            itN = itN.toLowerCase()
                            itN = itN.replaceAll(" ", "")
                            it_url = it_name + "/" + itN
                            it_url = 'https://www.betfair.it/exchange/plus/it/calcio/' + it_url + '-scommesse-' +tips[i].dailyApiEvents1[0].it_link.eventId;
                        }

                        let item = {
                            ...tips[i],
                            strategyId: tips[i].strategy,
                            view: tipView,
                            eventName: tips[i].betfairEvents[0].eventName,
                            strategyName: strategyName,
                            
                            bl: side,
                            predict: api_predictionType,
                            stake_pt: stake,
                            stake_money: stake_money,
                            status: tips[i].DailyFixtures[0].time.status,
                            minute: tips[i].DailyFixtures[0].time.minute ? tips[i].DailyFixtures[0].time.minute : defaultFormat(dateTime),
                            timestamp: tips[i].DailyFixtures[0].time.starting_at.timestamp,
                            score: tips[i].DailyFixtures[0].scores.localteam_score + " - " + tips[i].DailyFixtures[0].scores.visitorteam_score,
                            bet_status: bet_status,                            
                            entry_min: bet_status != "unmatched" ? entry_min : '',
                            entry_odd: bet_status != "unmatched" ? entry_odd : '',
                            pot_Profit: bet_status != "unmatched" ? pot_Profit : '',
                            curPL: bet_status != "unmatched" ? currentPointProfit : '',
                            cashOut: cashOut,
                            select: tipSelect,
                            action: false,
                            apiId: tips[i].betfairEvents[0].apiId,
                            betfairId: tips[i].betfairEvents[0].betfairId,
                            betfairEvent: tips[i].betfairEvents[0],
                            viceOdds: viceOdds,
                            marketStatus: marketStatus,
                            com_url: com_url,
                            it_url: it_url
                        }
                        
                        pendingTips.push(item);
                        if ( betfair_ids.includes(tips[i].betfairEvents[0]._id) === false ){
                            marketViews.push(tips[i].betfairEvents[0]);
                            betfair_ids.push(tips[i].betfairEvents[0]._id);
                        }
                        
                    }
                    
                    this.pendingTips = pendingTips;
                    this.marketViews = marketViews;
                    console.log("this.marketViews ", this.marketViews)

                    for ( var str_index = 0; str_index < myStrategies.length; str_index++) {
                        let strategy_pendingTips = this.pendingTips.filter( item => item.strategyId == myStrategies[str_index]._id.toString());
                        let strategy_curPL  = 0;
                        strategy_pendingTips.forEach(sItem => {
                            if ( sItem.curPL )
                                strategy_curPL += sItem.curPL;
                        });
                        if ( strategy_curPL )
                            strategy_curPL = strategy_curPL.toFixed(2);
                        myStrategies[str_index]["curPL"] = strategy_curPL;

                        myStrategies[str_index]["pendingTips"] = strategy_pendingTips.length;
                        myStrategies[str_index]["pendingMatchedTips"] = strategy_pendingTips.filter( item => item.bet_status == "placed").length;
                        myStrategies[str_index]["pendingPartialMatchedTips"] = strategy_pendingTips.filter( item => item.bet_status == "partial matched").length;
                    }
                    this.myStrategies = myStrategies;

                    this.loading = false;
                    
                });
            },
            updatePage() {

            },
            actionStrategy(_id, status) {
                Swal
                    .fire({
                        title: "Are you sure?",
                        text: "Do you confirm for this action?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sure",
                    })
                    .then((result) => {
                        if (result.value) {
                           this.deleteMyStrategy({_id: _id, status: status}).then((data) => {
                                let idx = this.myStrategies.findIndex(item => item._id === _id);
                                this.myStrategies[idx].betfair_status = status;
                            }).finally(() => {
                                console.log('final');
                            });
                        }
                    });
            },
            actionViewTips( _id ) {
                let routeData = this.$router.resolve({
                    name: 'betfairTips',
                    params: {
                        id: _id                        
                    }
                });
                window.open(routeData.href, '_blank');
            },

            playStrategy(_id, status) {
                this.setPlayStrategy({_id: _id, status: status}).then((data) => {
                    
                }).finally(() => {
                    console.log('final');
                });
            },
            autoStrategy(_id, status, betfair_setting) {
                
                if ( status ) {
                    if ( !betfair_setting || ( !betfair_setting.flat_stake && !betfair_setting.leverage && (!betfair_setting.budget || !betfair_setting.size_percent ) ) ) {
                        displayError( { message: "Please set Staking option first!"});
                        let index = this.myStrategies.findIndex( item => item._id == _id);
                        
                        this.myStrategies[index].auto = false;
                        this.myStrategyKey += 1;
                        return true;
                    }
                }
                this.setAutoStrategy({_id: _id, status: status}).then((data) => {
                    
                }).finally(() => {
                    console.log('final');
                });
            },
            strategyView(_id, status) {
                this.setStrategyView({_id: _id, status: status}).then((data) => {
                    
                }).finally(() => {
                    console.log('final');
                });
            },
            tipView(_id, status) {
                this.setTipView({_id: _id, status: status}).then((data) => {
                    
                }).finally(() => {
                    console.log('final');
                });
            },

            addBackRunner(marketId, selectionId, odds, runnerName, apiId) { 
                let oldBackRunners = this.back_runners.filter(item => item.marketId == marketId);
                let oldLayRunners = this.lay_runners.filter(item => item.marketId == marketId);
                
                let back_index = oldBackRunners.findIndex( item => item.selectionId == selectionId);
                if (back_index > -1)
                    oldBackRunners.splice(back_index, 1);
                else
                    oldBackRunners.push({
                        marketId: marketId,
                        selectionId: selectionId,
                        odds: odds,
                        runnerName: runnerName,
                        stake: '',
                        event: apiId
                    })

                this.back_runners = oldBackRunners;
                if (oldLayRunners.length == 0)
                    this.lay_runners = [];
            },
            addLayRunner(marketId, selectionId, odds, runnerName, apiId) {
                let oldBackRunners = this.back_runners.filter(item => item.marketId == marketId);
                let oldLayRunners = this.lay_runners.filter(item => item.marketId == marketId);

                let lay_index = oldLayRunners.findIndex( item => item.selectionId == selectionId);
                if (lay_index > -1)
                    oldLayRunners.splice(lay_index, 1);
                else
                    oldLayRunners.push({
                        marketId: marketId,
                        selectionId: selectionId,
                        odds: odds,
                        runnerName: runnerName,
                        stake: '',
                        event: apiId
                    })
                if (oldBackRunners.length == 0)
                    this.back_runners = [];
                
                this.lay_runners = oldLayRunners;
                
            },
            deleteBankRunner(selectionId) {
                this.back_runners = this.back_runners.filter( item => item.selectionId != selectionId)
            },
            deleteLayRunner(selectionId) {
                this.lay_runners = this.lay_runners.filter( item => item.selectionId != selectionId)
            },

            deleteAllBets(){
                this.lay_runners = [];
                this.back_runners = [];
                this.layPayout = true;
                this.layLiability = false;
            },

            manualOrder(item) {
                console.log(item);
                let betfairId = item.betfairId;
                let api_predictionType = item.predict;
                let betfair_marketType;

                if ( api_predictionType == "Home - FT" || api_predictionType == "Draw - FT" || api_predictionType == "Away - FT"  )
                    betfair_marketType = 'MATCH_ODDS';
                else if ( api_predictionType == 'Over - 0.5 - FT' || api_predictionType == 'Under - 0.5 - FT' )
                    betfair_marketType = 'OVER_UNDER_05';
                else if ( api_predictionType == 'Over - 1.5 - FT' || api_predictionType == 'Under - 1.5 - FT' )
                    betfair_marketType = 'OVER_UNDER_15';
                else if ( api_predictionType == 'Over - 2.5 - FT' || api_predictionType == 'Under - 2.5 - FT' )
                    betfair_marketType = 'OVER_UNDER_25';
                else if ( api_predictionType == 'Over - 3.5 - FT' || api_predictionType == 'Under - 3.5 - FT' )
                    betfair_marketType = 'OVER_UNDER_35';
                else if ( api_predictionType == 'Over - 4.5 - FT' || api_predictionType == 'Under - 4.5 - FT' )
                    betfair_marketType = 'OVER_UNDER_45';

                else if ( api_predictionType == 'BTS - FT' || api_predictionType == 'No BTS - FT' )
                    betfair_marketType = 'BOTH_TEAMS_TO_SCORE';

                else if ( api_predictionType == "Home - HT" || api_predictionType == "Draw - HT" || api_predictionType == "Away - HT"  )
                    betfair_marketType = 'HALF_TIME';

                else if ( api_predictionType == 'Over - 0.5 - HT' || api_predictionType == 'Under - 0.5 - HT' )
                    betfair_marketType = 'FIRST_HALF_GOALS_05';
                else if ( api_predictionType == 'Over - 1.5 - HT' || api_predictionType == 'Under - 1.5 - HT' )
                    betfair_marketType = 'FIRST_HALF_GOALS_15';
                else if ( api_predictionType == 'Over - 2.5 - HT' || api_predictionType == 'Under - 2.5 - HT' )
                    betfair_marketType = 'FIRST_HALF_GOALS_25';        

                else if ( api_predictionType == 'Home - Draw no bet' || api_predictionType == 'Away - Draw no bet' )
                    betfair_marketType = 'DRAW_NO_BET';

                else if ( api_predictionType == "1X - Double chance" || api_predictionType == "X2 - Double chance" || api_predictionType == "12 - Double chance"  )
                    betfair_marketType = 'MATCH_ODDS';
                
                if (betfair_marketType) {
                    
                    let betfair_event = item.betfairEvent;
                    if (betfair_event[betfair_marketType]){
                        let odds = betfair_event[betfair_marketType];
                        let marketId = odds.marketId;
                        let bl = item.bl;
                        let runner;
                        let  runnerName = api_predictionType;

                        this.lay_runners = [];
                        this.back_runners = [];

                        if (betfair_marketType == "MATCH_ODDS" || betfair_marketType == "HALF_TIME") {
                            if ( api_predictionType.includes("Home") ) {
                                runner = odds.runners[0];
                                // runnerName = item.eventName.split(' v ')[0];
                            }
                            else if ( api_predictionType.includes("Away") ) {
                                runner = odds.runners[1];
                                // runnerName = item.eventName.split(' v ')[1];
                            }
                            else if ( api_predictionType.includes("Draw") ) {
                                runner = odds.runners[2];
                                // runnerName = "Draw";
                            }
                           
                        }

                        else if (betfair_marketType.includes("OVER_UNDER_") || betfair_marketType.includes("FIRST_HALF_GOALS_")) {
                            if ( api_predictionType.includes("Under") ) {
                                runner = odds.runners[0];
                            }
                            else if ( api_predictionType.includes("Over") ) {
                                runner = odds.runners[1];
                            }
                            
                            
                        }
                        else if (betfair_marketType == 'BOTH_TEAMS_TO_SCORE' ) {
                            if ( api_predictionType == 'BTS - FT' ) {
                                runner = odds.runners[0];
                            }
                            else if ( api_predictionType == 'No BTS - FT' ) {
                                runner = odds.runners[1];
                            } 
                        }
                        else if (betfair_marketType == 'DRAW_NO_BET' ) {
                            if ( api_predictionType == 'Home - Draw no bet' ) {
                                runner = odds.runners[0];
                            }
                            else if ( api_predictionType == 'Away - Draw no bet' ) {
                                runner = odds.runners[1];
                            } 
                        }

                        if (runner && bl) {
                            if ( bl == "BACK") {
                                if (runner.ex["availableToBack"].length > 0) {
                                    this.back_runners.push({
                                        marketId: marketId,
                                        selectionId: runner.selectionId,
                                        odds: runner.ex["availableToBack"][0].price,
                                        runnerName: runnerName,
                                        betfairTipId: item._id,
                                        stake: '',
                                        event: item.apiId
                                    })
                                }
                                else {
                                    displayError({ message: "Odds not available "});
                                }
                            }
                            else if ( bl == "LAY") {
                                if (runner.ex["availableToLay"].length > 0) {
                                    this.lay_runners.push({
                                        marketId: marketId,
                                        selectionId: runner.selectionId,
                                        odds: runner.ex["availableToLay"][0].price,
                                        runnerName: runnerName,
                                        betfairTipId: item._id,
                                        stake: '',
                                        event: item.apiId
                                    })
                                }
                                else {
                                    displayError({ message: "Odds not available "});
                                }
                            }
                        }
                    }
                }

            },

            placeBets() {
                let marketId;
                let betfairTipId;
                let event;
                let selectionId_predictionType = [];

                let instructions = [];
                if (this.back_runners.length > 0) {
                    marketId = this.back_runners[0].marketId;
                    betfairTipId = this.back_runners[0].betfairTipId;
                    event = this.back_runners[0].event;
                    for ( var i=0; i < this.back_runners.length; i++) {
                        let runner = this.back_runners[i];
                        if (runner.odds && runner.stake) {
                            instructions.push({
                                selectionId: runner.selectionId.toString(),
                                handicap: "0",
                                side: "BACK",
                                orderType: "LIMIT",
                                limitOrder: {
                                    price: runner.odds.toString(),
                                    size: runner.stake.toString()
                                }                               

                            });
                            selectionId_predictionType.push({
                                selectionId: runner.selectionId.toString(),
                                predictionType: runner.runnerName
                            })
                        }
                    }

                }

                let betTargetType = "BACKERS_PROFIT";
                if (this.layPayout)
                    betTargetType = "PAYOUT";

                if (this.lay_runners.length > 0) {
                    marketId = this.lay_runners[0].marketId;
                    betfairTipId = this.lay_runners[0].betfairTipId;
                    event = this.lay_runners[0].event;
                    for ( var i=0; i < this.lay_runners.length; i++) {
                        let runner = this.lay_runners[i];
                        if (runner.odds && runner.stake) {
                            
                            instructions.push({
                                selectionId: runner.selectionId.toString(),
                                handicap: "0",
                                side: "LAY",
                                orderType: "LIMIT",
                                limitOrder: {
                                    price: runner.odds.toString(),
                                    size: runner.stake.toString(),
                                    // betTargetType: betTargetType
                                }
                            });
                            selectionId_predictionType.push({
                                selectionId: runner.selectionId.toString(),
                                predictionType: runner.runnerName
                            });
                        }
                    }
                }

                if (instructions.length > 0) {
                    let params = {
                        marketId: marketId,
                        instructions: instructions
                    };

                    console.log(params);
                    this.placeOrders({ betfairTipId: betfairTipId, params: params, event: event, selectionId_predictionType: selectionId_predictionType }) .then((data) => {
                        if (data.status == "success") {
                            displaySuccess({message: "Successfully placed order"});
                        }
                        else {
                            displayError({message: data.message});
                        }
                        console.log(data)
                    }).finally(() => {
                        console.log("final")
                    });
                }
            },

            cashOut(item) {

                let instructions = [];
                let instruction = item.instruction;
                let betTargetType = "PAYOUT";

                let new_instruction = {
                    selectionId: instruction.selectionId.toString(),
                    handicap: "0",
                    orderType: instruction.orderType,
                    limitOrder: {
                        size: item.cashOut.toString(),
                        price: item.viceOdds.toString()
                    }
                }

                if (instruction.side == "BACK"){

                    new_instruction.side = "LAY";
                    // new_instruction.limitOrder.betTargetType = betTargetType;
                    
                }
                else{
                    new_instruction.side = "BACK";
                }

                instructions.push(new_instruction);

                let predictionType = item.predict;               

                if (instructions.length > 0) {
                    let params = {
                        marketId: item.marketId,
                        instructions: instructions
                    };

                    this.betfairCashout({ betfairTipId: item._id, params: params, event: item.event, predictionType: predictionType, cashOuted: item._id }) .then((data) => {
                        if (data.status == "success") {
                            displaySuccess({message: "Successfully placed order"});
                        }
                        else {
                            displayError({message: data.message});
                        }
                        console.log(data)
                    }).finally(() => {
                        console.log("final")
                    });
                }
            },

            actionDeleteOrder(marketId, betId) {
                this.deleteOrder({ marketId: marketId, betId: betId}).then((data) => {
                    if (data.status == "success") {
                        displaySuccess({message: "Successfully deleted order"});
                    }
                    else {
                        displayError({message: data.message});
                    }
                    console.log(data)
                }).finally(() => {
                    console.log("final")
                });
            },

            actionUpdateOrder(marketId, betId) {
                this.updateOrder({ marketId: marketId, betId: betId}).then((data) => {
                    if (data.status == "success") {
                        displaySuccess({message: "Successfully updated order"});
                    }
                    else {
                        displayError({message: data.message});
                    }
                    console.log(data)
                }).finally(() => {
                    console.log("final")
                });
            },

            actionResetStrategyStats(_id) {
                console.log( _id );
                this.resetStrategyStats( { _id: _id }).then((data) => {
                    if (data.status == "success") {
                        displaySuccess({message: "Successfully reset stats"});
                    }
                    else {
                        displayError({message: data.message});
                    }
                    console.log(data)
                }).finally(() => {
                    console.log("final")
                });
            },

            tipSort(field) {
                console.log('field', field);
                if ( this.tips_filter[field] == 0 )
                    this.tips_filter[field] = 1;
                else
                    this.tips_filter[field] *= -1;

                for (const param of Object.keys(this.tips_filter)) {
                    if ( param != field )
                        this.tips_filter[param] = 0;
                }

                console.log(this.tips_filter);

            },

            sortJSON1(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            sortJSON2(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x > y) ? -1 : ((x < y) ? 1 : 0));
                });
            },
           
        },
       
        mounted() {
            this.sockets.subscribe('UpdateBetfairSettled', ({settledBetfairEvents}) => {
                console.log("settledBetfairEvents=>>>>>>>>>>>>>>>>>>>>>>", settledBetfairEvents);

                this.pendingTips = this.pendingTips.filter( item => settledBetfairEvents.includes(item.betfairId.toString()) == false );
                this.marketViews = this.marketViews.filter( item => settledBetfairEvents.includes(item.betfairId.toString()) == false );
            });

            this.sockets.subscribe('UpdateMarketProfits', ({profitResult}) => {
                this.marketProfits = profitResult;
                console.log("profitResult=>>>>>>>>>>>>>>>>>>>>>>", this.marketProfits);
                
                //this.marketViews = this.marketViews.filter( item => settledBetfairEvents.includes(item.betfairId.toString()) == false );
            });

            this.sockets.subscribe('tipCashouted', ({tipId, cashoutType}) => {
                
                console.log("tipCashouted=>>>>>>>>>>>>>>>>>>>>>>", tipId, cashoutType);
                let index = this.pendingTips.findIndex( item => item._id == tipId && item.type == cashoutType );
                if ( index > -1 ) {
                    let apiTip = this.pendingTips[index];
                    if ( apiTip.instruction && apiTip.betfairCashouts.length == 0 ) {
                        if ( apiTip.cashOut && apiTip.sizeMatched && apiTip.marketStatus == 'OPEN' ) {
                            this.cashOut( apiTip );
                        }
                    }
                }
            });

            this.updatePageTimer = setInterval(this.getStrategies, 16 * 1000);
        },
        created() {
            this.loading = true;
            // this.getStrategies();
            this.check_BetfairLogin();
        },
        beforeDestroy() {
            clearInterval(this.updatePageTimer);
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
    .card_background{
        padding: 10px;
        padding-top: 26px;
    }

    .card_background > .card-body{
        background-color: #f5f5f5;
        border-radius: 10px;
        border: 1px solid lightgray;
    }
    .post-tip-container {
        .action-btns {
            button {
                min-width: 80px;
            }
        }
    }
    .best_top_select{
        width: 31.7%;
    }
    @media (max-width: 576px) {
      .best_top_select{
          width: 100%;
      }
    }
    .table_pre_row {
        background: rgba(193, 176, 215, 0.75);
        border-left: 1px solid white;
        height: 30px;
        padding: 0px;
        min-width: 100px;
    }
    .market_header {
        border-color: white;
        border-width: 1px;
        border-style: ridge;
        background: rgb(183, 234, 252);
    }
    .market_row {
        border-color: white;
        border-width: 1px;
        border-style: ridge;        
    }
    .back_odd {
        background-color: #a6d8ff;
        cursor: pointer;
        border-right: 1px solid #fff;
        border-left: none;
        text-align: center
    }
    .back_odd:hover {
        background-color: #75c2fd;     
    }
    .back_odd_stick {
        background-color: #a6d8ff;        
        border-right: 1px solid #fff;
        border-left: none;
        text-align: center
    }
    
    .lay_odd {
        background-color: #fac9d4;
        cursor: pointer;
        border-left: 1px solid #fff;
        border-right: none;
        text-align: center;
    }
    .lay_odd:hover {
        background-color: #f694aa;
        cursor: pointer;
    }
    .lay_odd_stick {
        background-color: #fac9d4;        
        border-left: 1px solid #fff;
        border-right: none;
        text-align: center;
    }

    .bet-button-price {
        font-weight: 700;
        display: block;
    }

    .bet-button-size {
        font-size: 15px;
        display: block;
    }

    .error-message__statement {
        font-weight: 700;
        font-size: 1.1rem;
        color: #bc4848;
    }
    .table-layout {
        overflow-x: auto;
        overflow-y: auto;
        height: 378px;
    }
    .market-view {
        overflow-x: auto;
        overflow-y: auto;
        height: 550px;
    }
    .market-total-profit {
        padding-right: 5px;
        color: red;
    }
    .table-header-stick {
        background: rgb(183, 234, 252);
        padding: 3px;
        position: sticky;
        top: 0;
        z-index: 1;
    }
    .bets-table {
        overflow-x: auto;
        overflow-y: auto;
    }
    .form-group {
        margin-bottom: 5px !important;
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
    .dlg-setting-section {
        background-color: lavenderblush;
        margin-bottom: 15px;
    }
    .dlg-setting-section-title {
        color: blue;
        padding-top: 10px;
        padding-left: 10px;
    }
    .bet-row {
        border-bottom-color: white;
        border-bottom-style: ridge;
    }
    
</style>